export const SET_CENTRE = 'SET_CENTRE'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_STATUS_LIST = 'SET_STATUS_LIST'
export const RESET_CENTRE = 'RESET_CENTRE'
